module.exports = __webpack_public_path__ + "static/create-account-587d3aa2d3cfb53d49ea5d236f2a507e.png";